// Mirrors Tp_Communication.Enum.InvoiceAutomationRunChangeTypeTextEnum — keep in sync.
const InvoiceAutomationRunChangeTypeEnum = {
  DraftCreated: 'DraftCreated',
  DraftRecreated: 'DraftRecreated',
  JobAdded: 'JobAdded',
  LateJobMoved: 'LateJobMoved',
  JobBroughtIn: 'JobBroughtIn',
  JobRemoved: 'JobRemoved',
  JobSkipped: 'JobSkipped',
  FulfillmentDateMoved: 'FulfillmentDateMoved',
};

export default InvoiceAutomationRunChangeTypeEnum;
